import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Header from '../Header';
import Footer from '../Footer';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import errorimg from "../../img/others/error.png"

const PageNotFound = () => {



    return (
        <>
            <div class="error-area sp">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-8 m-auto text-center">
                            <div class="main-image">
                                <img src={errorimg} alt="" />
                            </div>
                            <div class="space40"></div>
                            <div class="heading1">
                                <h2>Page not found!</h2>
                                <div class="space16"></div>
                                <p>Sorry, the page you are looking for doesn’t exist <br /> or has been moved. Here are some helpful links.</p>
                                <div class="space30"></div>
                                <div class="button">
                                    <a class="theme-btn1 btn btn--ripple ripple" href="/">Back To Home Page <FontAwesomeIcon icon={faArrowRight} transform={{ rotate: 315 }} style={{ marginLeft: "5px" }} /></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PageNotFound